var storefrontApp = angular.module("storefrontApp");
//#region Home Service
storefrontApp.service('homeService', ['$http', function ($http) {
    return {
        getHomepageContent: function () {
            return $http.get('storefrontapi/homepage-content');
        },
        getDigitalEvents: function (count) {
            return $http.get('storefrontapi/digitalevents?count='+count);
        },
        getEmbroideryProjects: function (count) {
            return $http.get('storefrontapi/learningcenter/embroideryprojects?count=' + count);
        },
        getTopLookbooks: function (count) {
            return $http.get('storefrontapi/learningcenter/toplookbooks?count='+count);
        },
        getProjectsAndLookbooks: function (projectCount, lookbookCount) {
            return $http.get('storefrontapi/getprojectsandlookbooks/' + projectCount + '/' + lookbookCount);
        },
        getMainAds: function(count) {
            if(count > 0){
                return $http.get('storefrontapi/carousel-ads?count=' + count);
            }
            else{
                return $http.get('storefrontapi/carousel-ads');
            }
        }
    }
}]);
//#endregion
